import { Route, Routes, Navigate } from "react-router-dom";
import Dashboard from "@/planner/pages/Dashboard";
import Products from "@/planner/pages/Products";
import Machines from "@/planner/pages/Machines";
import MachineDetail from "@/planner/pages/MachineDetail";
import FillPlanner from "@/planner/pages/FillPlanner";
import Inventory from "@/planner/pages/Inventory";
import RoutePlanner from "@/planner/pages/RoutePlanner";
import ShoppingLists from "@/planner/pages/ShoppingLists";
import Settings from "@/planner/pages/Settings";
import Receipts from "@/planner/pages/Receipts";
import CountStock from "@/planner/pages/CountStock";

const BASE = "/admin/planner";

// VendingPlanner, ported from the standalone app. The workspace layout (src/app/AdminApp.jsx)
// handles sign-in and the menu; this only maps /admin/planner/* to its pages.
const Planner = () => (
  <div className="planner-scope" data-testid="planner-page">
    <Routes>
      <Route index element={<Dashboard />} />
      <Route path="machines" element={<Machines />} />
      <Route path="machines/:id" element={<MachineDetail />} />
      <Route path="products" element={<Products />} />
      <Route path="fill-planner" element={<FillPlanner />} />
      <Route path="inventory" element={<Inventory />} />
      <Route path="route" element={<RoutePlanner />} />
      <Route path="shopping" element={<ShoppingLists />} />
      <Route path="count" element={<CountStock />} />
      <Route path="receipts" element={<Receipts />} />
      <Route path="settings" element={<Settings />} />
      <Route path="*" element={<Navigate to={BASE} replace />} />
    </Routes>
  </div>
);

export default Planner;
